import { Col, Row, Button } from "react-bootstrap";

export default function ResultEach() {
    return (
        <div></div>
    )
}